import dayjs from 'dayjs';
import { useReleaseNoteDetailQuery } from '~/apis/releaseNote';
import { ReleaseReleaseNoteProtocolsGetDetailResponse } from '~/swagger/data-contracts';

export const useViewModel = (selectedId: number) => {
  const { isLoading, data } = useReleaseNoteDetailQuery({ id: selectedId }, { select: parseDetail });

  return {
    isLoading,
    data,
  };
};

const parseDetail = (data: ReleaseReleaseNoteProtocolsGetDetailResponse) => {
  return {
    title: data.title,
    content: data.content,
    mainContent: data.main_image_url || undefined,
    date: dayjs(data.publish_date).format('MMM D, YYYY'),
  };
};
